import { render } from "./body.vue?vue&type=template&id=14e3ced4&scoped=true"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"

import "./body.vue?vue&type=style&index=0&id=14e3ced4&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e3ced4"]])

export default __exports__